import React from "react";
import { Link } from "react-router-dom";
import { SEASONAL_TILES } from "@/lib/constants";
import { useSeasonalTiles } from "@/lib/useContentBlocks";
export default function SeasonalSpice() {
  const tiles = useSeasonalTiles(SEASONAL_TILES);
  return (
    <main className="sq-container py-12" data-testid="seasonal-page">
      <div className="sq-eyebrow">Edits</div>
      <h1 className="font-display text-5xl md:text-6xl mt-2">Seasonal Spice</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mt-10">
        {tiles.map((t, i) => (
          <Link key={t.id || i} to={t.slug ? `/shop-by-occasion/${t.slug}` : (t.route || "/fabrics")} data-testid={`seasonal-tile-${i}`} className="group">
            <div className="relative aspect-[3/4] overflow-hidden">
              <img src={t.image} alt={t.name} className="absolute inset-0 w-full h-full object-cover group-hover:opacity-0 transition-opacity duration-700" />
              <img src={t.hover || t.image} alt={t.name} className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
            </div>
            <div className="font-display text-xl mt-3">{t.name}</div>
          </Link>
        ))}
      </div>
    </main>
  );
}
